var map = {
	"./comments.svg": 775,
	"./copy-link.svg": 748,
	"./facebook.svg": 826,
	"./like-fill.svg": 773,
	"./like.svg": 774,
	"./ok.svg": 827,
	"./share.svg": 776,
	"./telegram.svg": 828,
	"./twitter.svg": 829,
	"./vk.svg": 830,
	"./whatsapp.svg": 831
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 825;